import React, {useState} from 'react';
import Card from '../components/Card';
import "../styles/responsive.css"

const CardStack = (props) => {

  const [isClicked, setIsClicked] = useState(false);
 


  return (
    <div className={`row ${isClicked ? 'row-expanded' : ''}`}>
      <Card title="card0" content={isClicked ? 'noshow' : ''} />
      <Card title="card1" content="Content for Card 1"  />
      <Card title="card2" content="Content for Card 2"  />
      <Card title="card3" content="Content for Card 3" />

      {/* Add more Card components as needed */}
    </div>
  );
};

export default CardStack;